module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Vuety;
function Vuety(id, target) {
    return function (callback) {
        if (!target.$vuety) {
            target.$vuety = {};
        }
        if (!target.$vuety[id]) {
            target.$vuety[id] = [callback];
        }
        else {
            target.$vuety[id].push(callback);
        }
    };
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = processEventArgs;
/* harmony export (immutable) */ __webpack_exports__["b"] = merge;
function processEventArgs(arg1, arg2) {
    var targetFn = null;
    var evtName = null;
    if (typeof arg1 === "string") {
        evtName = arg1;
        if (arg2 && typeof arg2 !== "string") {
            targetFn = arg2;
        }
    }
    else {
        if (arg1) {
            targetFn = arg1;
        }
        if (typeof arg2 === "string") {
            evtName = arg2;
        }
    }
    return { targetFn: targetFn, evtName: evtName };
}
function merge(key, options, handler) {
    if (!options[key]) {
        options[key] = [handler];
    }
    else if (options[key] instanceof Array) {
        options[key].push(handler);
    }
    else {
        options[key] = options[key].concat([handler]);
    }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Component;

var defaultStore = new Map();
function Component(options) {
    var opts = options || {};
    return function (target) {
        var proto = target.prototype;
        var instance;
        var vuety = proto.$vuety;
        if (vuety) {
            var getDefault = function (key) {
                var store = defaultStore.get(target);
                if (store == null) {
                    store = {};
                    defaultStore.set(target, store);
                }
                if (key in store) {
                    return store[key];
                }
                if (!instance) {
                    instance = new target();
                }
                store[key] = instance[key];
                var t = typeof store[key];
                switch (t) {
                    case "string":
                    case "number":
                    case "boolean":
                    case "undefined":
                        break;
                    case "object":
                        if (store[key] === null) {
                            break;
                        }
                    default:
                        if (!__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.silent) {
                            console.warn("[vuety] avoid using non-primative objects via class assignment [#10]", opts.name || "(unnamed component)" + "." + key + " -> " + t);
                        }
                }
                return store[key];
            };
            var keys_1 = Object.keys(vuety);
            var doneCallbacks_1 = {};
            var data_1 = undefined;
            var _loop_1 = function (i) {
                var callbacks = vuety[keys_1[i]];
                for (var j = 0; j < callbacks.length; j++) {
                    callbacks[j]({
                        options: opts,
                        getDefault: getDefault,
                        storeData: function (key, factory) {
                            if (!data_1)
                                data_1 = {};
                            data_1[key] = factory;
                        },
                        proto: proto,
                        done: function (cb) {
                            if (!(keys_1[i] in doneCallbacks_1)) {
                                doneCallbacks_1[keys_1[i]] = cb;
                            }
                        },
                    });
                }
            };
            for (var i = 0; i < keys_1.length; i++) {
                _loop_1(i);
            }
            if (data_1) {
                var _data_1 = data_1;
                opts.data = function () {
                    var r = {};
                    Object.keys(_data_1).forEach(function (k) {
                        r[k] = _data_1[k]();
                    });
                    return r;
                };
            }
            Object.keys(doneCallbacks_1).forEach(function (decoratorId) {
                doneCallbacks_1[decoratorId]({
                    proto: proto,
                    options: opts,
                });
            });
            delete proto.$vuety;
        }
        // Loop over each method in the class and see if it needs to be set as a method or computed property
        Object.getOwnPropertyNames(target.prototype)
            .filter(function (p) { return p !== "constructor"; })
            .forEach(function (prop) {
            var descriptor = Object.getOwnPropertyDescriptor(target.prototype, prop);
            if (descriptor.get || descriptor.set) {
                delete target.prototype[prop];
                if (!opts.computed) {
                    opts.computed = {};
                }
                if (descriptor.get === undefined) {
                    throw new Error("Computed properties must have a getter: " + target.prototype.constructor.name + "." + prop);
                }
                opts.computed[prop] = {
                    get: descriptor.get,
                    set: descriptor.set,
                };
            }
            else {
                if (!opts.methods) {
                    opts.methods = {};
                }
                opts.methods[prop] = descriptor.value;
            }
        });
        if (!opts.name && target.name)
            opts.name = target.name;
        return target.extend(opts);
    };
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Data;

function Data() {
    function data(factory, target, propertyKey) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Data", target)(function (v) {
            if (!factory) {
                var val_1 = v.getDefault(propertyKey);
                factory = function () { return val_1; };
            }
            v.storeData(propertyKey, factory);
        });
    }
    if (arguments.length < 3) {
        var args_1 = arguments;
        return function () {
            data.apply(this, [args_1[0]].concat(Array.from(arguments)));
        };
    }
    else {
        data.apply(this, [undefined].concat(Array.from(arguments)));
    }
    return;
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = Emit;

function Emit() {
    function emit(arg1, arg2, target, propertyKey, descriptor) {
        var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* processEventArgs */])(arg1, arg2);
        var orig = descriptor.value;
        descriptor.value = function () {
            var target;
            if (r.targetFn) {
                target = r.targetFn(this);
            }
            else {
                target = this;
            }
            // Call original function first
            var res = orig.apply(this, arguments);
            // Then raise the event
            target.$emit.apply(target, [r.evtName || propertyKey].concat(Array.from(arguments)));
            // Then if the original function supplied a callback, invoke that
            if (typeof res === "function") {
                res.apply(this, arguments);
            }
        };
    }
    var args = Array.from(arguments);
    if (args.length === 3) {
        if ("value" in args[2] && args[2]["value"] instanceof Function) {
            emit.apply(this, Array(2).concat(args));
            return;
        }
    }
    args.length = 2;
    return function () {
        emit.apply(this, args.concat(Array.from(arguments)));
    };
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Inject;


function Inject() {
    function inject(dependencyNameOrOptions, target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Vuety */])("Inject", target)(function (v) {
            if (!v.options.inject) {
                v.options.inject = {};
            }
            v.options.inject[propertyKey] = dependencyNameOrOptions || propertyKey;
            delete v.proto[propertyKey];
        });
    }
    var args = Array.from(arguments);
    if (args[0] instanceof __WEBPACK_IMPORTED_MODULE_0_vue__) {
        inject.apply(this, [undefined].concat(args));
        return;
    }
    else {
        args.length = 1;
        return function () {
            inject.apply(this, args.concat(Array.from(arguments)));
        };
    }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Lifecycle;

function Lifecycle() {
    function lifecycle(target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Lifecycle", target)(function (v) {
            if (!v.options[propertyKey]) {
                v.options[propertyKey] = [descriptor.value];
            }
            else if (v.options[propertyKey] instanceof Array) {
                v.options[propertyKey].push(descriptor.value);
            }
            else {
                v.options[propertyKey] = [v.options[propertyKey], descriptor.value];
            }
        });
    }
    if (arguments.length === 0) {
        return function () {
            lifecycle.apply(this, arguments);
        };
    }
    else {
        lifecycle.apply(this, arguments);
    }
    return;
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = On;


function On() {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    function on(arg1, arg2, target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("On", target)(function (v) {
            var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* processEventArgs */])(arg1, arg2);
            var handler = function () {
                var target = r.targetFn ? r.targetFn(this) : this;
                var listener = descriptor.value.bind(this);
                target.$on(r.evtName || propertyKey, listener);
                this.$on("hook:destroyed", function () {
                    target.$off(r.evtName || propertyKey, listener);
                });
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* merge */])("beforeCreate", v.options, handler);
        });
    }
    var args = Array.from(arguments);
    if (args.length === 3) {
        if ("value" in args[2] && args[2]["value"] instanceof Function) {
            on.apply(this, Array(2).concat(args));
            return;
        }
    }
    args.length = 2;
    return function () {
        on.apply(this, args.concat(Array.from(arguments)));
    };
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Prop;

function Prop() {
    function prop(options, target, propertyKey) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Prop", target)(function (v) {
            if (!options) {
                options = {};
            }
            if (!options.default) {
                options.default = v.getDefault(propertyKey);
            }
            if (!options.type && options.default) {
                if (options.default.constructor !== Function) {
                    options.type = options.default.constructor;
                }
            }
            var props = {};
            props[propertyKey] = options;
            v.options.props = Object.assign({}, v.options.props, props);
        });
    }
    if (arguments.length < 3) {
        var args_1 = arguments;
        return function () {
            prop.apply(this, [args_1[0]].concat(Array.from(arguments)));
        };
    }
    else {
        prop.apply(this, [undefined].concat(Array.from(arguments)));
    }
    return;
}
(function (Prop) {
    Prop.warn = true;
})(Prop || (Prop = {}));


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Provide;


function Provide() {
    function provide(dependencyName, target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Vuety */])("Provide", target)(function (v) {
            var provided = (v.proto["$vuety-provide"] = v.proto["$vuety-provide"] || {});
            provided[dependencyName || propertyKey] = propertyKey;
            v.done(function (data) {
                delete v.proto["$vuety-provide"];
                data.options.provide = function () {
                    var _this = this;
                    var provide = {};
                    Object.keys(provided).forEach(function (k) { return (provide[k] = _this[provided[k]]); });
                    return provide;
                };
            });
        });
    }
    var args = Array.from(arguments);
    if (args[0] instanceof __WEBPACK_IMPORTED_MODULE_0_vue__) {
        provide.apply(this, [undefined].concat(args));
        return;
    }
    else {
        args.length = 1;
        return function () {
            provide.apply(this, args.concat(Array.from(arguments)));
        };
    }
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Render;

function Render() {
    function render(target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Render", target)(function (v) {
            v.options.render = descriptor.value;
            delete v.proto.render;
        });
    }
    if (arguments.length === 0) {
        return function () {
            render.apply(this, arguments);
        };
    }
    else {
        return render.apply(this, arguments);
    }
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Watch;

function Watch(watchee, options) {
    return function (target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Watch", target)(function (v) {
            if (!options) {
                options = {};
            }
            var original = descriptor.value;
            descriptor.value = function () {
                original.apply(this, Array.from(arguments).concat([watchee]));
            };
            options["handler"] = descriptor.value;
            var watches = {};
            watches[watchee] = options;
            v.options.watch = Object.assign({}, v.options.watch, watches);
        });
    };
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(3);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(0);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Vuety", function() { return __WEBPACK_IMPORTED_MODULE_1__core__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(4);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Data", function() { return __WEBPACK_IMPORTED_MODULE_2__data__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle__ = __webpack_require__(7);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Lifecycle", function() { return __WEBPACK_IMPORTED_MODULE_3__lifecycle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop__ = __webpack_require__(9);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Prop", function() { return __WEBPACK_IMPORTED_MODULE_4__prop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__render__ = __webpack_require__(11);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Render", function() { return __WEBPACK_IMPORTED_MODULE_5__render__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__watch__ = __webpack_require__(12);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Watch", function() { return __WEBPACK_IMPORTED_MODULE_6__watch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__on__ = __webpack_require__(8);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "On", function() { return __WEBPACK_IMPORTED_MODULE_7__on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emit__ = __webpack_require__(5);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Emit", function() { return __WEBPACK_IMPORTED_MODULE_8__emit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__provide__ = __webpack_require__(10);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Provide", function() { return __WEBPACK_IMPORTED_MODULE_9__provide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inject__ = __webpack_require__(6);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Inject", function() { return __WEBPACK_IMPORTED_MODULE_10__inject__["a"]; });













/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/vuety/dist/bundle.js
// module id = 0
// module chunks = 0